import { useState } from 'react'
import { createToastInstance } from '../functions'
import { ToastData, ToastInstance, UseToast } from '../types'

export const useToastProvider = (): UseToast => {
  const [toasts, setToasts] = useState<ToastInstance[]>([])

  const addToast = (instance: ToastInstance) => setToasts((value) => [...value, instance])

  const create = (data: ToastData) => {
    const instance = createToastInstance(data)
    addToast(instance)
    return instance
  }

  const update = (id: string, _update: Partial<ToastInstance>) => {
    setToasts((items) => {
      return items.map((item) => {
        return item.id === id ? { ...item, ..._update } : item
      })
    })
  }

  const remove = (id: string) =>
    setToasts((value) => value.filter((instance) => instance.id !== id))

  return { toasts, create, remove, update }
}
